import {FilterProviderType} from '@github-ui/filter'
import {StaticFilterProvider} from '@github-ui/filter/providers'
import {
  BriefcaseIcon,
  CheckboxIcon,
  GlobeIcon,
  KeyAsteriskIcon,
  MultiSelectIcon,
  NoteIcon,
  OrganizationIcon,
  SingleSelectIcon,
  TypographyIcon,
} from '@primer/octicons-react'

export class ManagedByFilterProvider extends StaticFilterProvider {
  constructor() {
    const filter = {
      displayName: 'Managed by',
      key: 'managed-by',
      description: 'Include properties managed by the enterprise and/or any of its organizations',
      priority: 1,
      icon: BriefcaseIcon,
    }

    const values = [
      {value: 'enterprise', displayName: 'Enterprise', icon: GlobeIcon, priority: 1},
      {value: 'organization', displayName: 'Organization', icon: OrganizationIcon, priority: 2},
    ]

    super(filter, values, {filterTypes: {multiKey: false, multiValue: true, valueless: false, exclusive: true}})
    this.type = FilterProviderType.Select
  }
}

export class PropertyTypeFilterProvider extends StaticFilterProvider {
  constructor() {
    const filter = {
      displayName: 'Property type',
      key: 'value-type',
      description: 'Filter definitions by type',
      priority: 1,
      icon: NoteIcon,
    }

    const values = [
      {value: 'text', displayName: 'Text', icon: TypographyIcon, priority: 1},
      {value: 'single_select', displayName: 'Single select', icon: SingleSelectIcon, priority: 2},
      {value: 'multi_select', displayName: 'Multi select', icon: MultiSelectIcon, priority: 3},
      {value: 'true_false', displayName: 'True/false', icon: CheckboxIcon, priority: 4},
    ]

    super(filter, values, {filterTypes: {multiKey: false, multiValue: true, valueless: false, exclusive: true}})
    this.type = FilterProviderType.Select
  }
}

export class RequiredFilterProvider extends StaticFilterProvider {
  constructor() {
    const filter = {
      displayName: 'Required',
      key: 'required',
      description: 'Filter definitions by whether they are required or optional',
      priority: 1,
      icon: KeyAsteriskIcon,
    }

    const values = [
      {value: 'true', displayName: 'True', priority: 1},
      {value: 'false', displayName: 'False', priority: 2},
    ]

    super(filter, values, {filterTypes: {multiKey: false, multiValue: false, valueless: false, exclusive: true}})
    this.type = FilterProviderType.Select
  }
}
